export const ROUTES = {
    HOME: {
        path: "/"
    },
    LOGIN:{
      path:"/login"
    },
    DASHBOARD: {
        path: "/dashboard"
    },
    MAP: {
        path: "/map"
    },
    PLANNING: {
        path:"/planning"
    },
    HANDBOOK: {
        path: "handbook",
        ORGANIZATIONS: "organizations",
        CONTRACTORS: "contractors",
        SCHEDULE: "schedule",
        CONTAINER_SITES: "container-sites",
        CONTAINER_SITES_TYPES: "container-sites-types",
        GEOZONES: "geozones",
        CONTAINERS: "containers",
        CONTAINER_TYPES: "container-types",
        VEHICLES: "vehicles",
        VEHICLE_STATUSES: "vehicle-statuses",
        WASTE_TYPES: "waste-types",
        LOAD_TYPES: "load-types",
        GROUP_GEOFENCE: "group-geofence",
    },
    REPORT:{
        path:"/report"
    },
    ADMIN:{
        path:"/admin-panel"
    },
    //TODO реализовать компонент
    NOT_ALLOWED: {
        path: "/not-allowed"
    },
    ADMIN_USERS: {
        path: "/admin-panel/users",
        create: "/admin-panel/users/create",
        update: "/admin-panel/users/update",
    },

    ADMIN_ROLES: {
        path: "/admin-panel/roles",
        create: "/admin-panel/roles/create",
        update: "/admin-panel/roles/update",
    },

    ADMIN_POSITIONS: {
        path: "/admin-panel/positions",
        create: "/admin-panel/positions/create",
        update: "/admin-panel/positions/update",
    },
}as const;